import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { CarpaService } from "@core-lib/services";
import { getHomeFullPath } from '@app/routes-definitions';

@Injectable({
	providedIn: 'root'
})

export class RouteWithParisTenantGuard  {
    constructor(
		private router: Router,
        private carpaService: CarpaService
	) {}

    canActivate(): boolean | UrlTree {
        // check if tenant Paris
        if (this.carpaService?.currentCarpa?.tenantKey === 'paris') {
            return true;
        }
        return this.router.createUrlTree([getHomeFullPath()]);
    }
}
